import React, { Component } from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import content from 'pp-react-l10n'
import { get, isEmpty } from 'lodash'
import { toggleCashAdvanceFeesOverpanel } from 'transfer/actions/overpanels'
import * as Styles from './cash-advance-fees-styling'
import {
  buildFundingSourceDisplayName,
  generateSourceLogoUrls,
  buildFundingSourceAccountType,
} from '../../utils/funding-option-utils'
import {
  trackCashAdvanceFeesImpression,
  trackCashAdvanceFeesClick,
} from '../../utils/cash-advance-fees-analytics'
import { getTheFundingSourceWithCashAdvanceFee } from './cash-advance-fees-util'
import { post } from '../../../calculator/lib/xhr'
import { tracking } from '../../../lib/analytics/mParticle'
import Events from '../../../lib/analytics/eventTags'
import { back } from '../../utils/routeHelper'
import { isDw2Repaint } from 'experiments/dw2Repaint'
import { BodyText } from '@paypalcorp/pp-react'
import { Button } from '@paypalcorp/pp-react'
import { mobileAndSmaller } from '../../../lib/styles/media-queries'
import glamorous from 'glamorous'

let i18n = content('transfer/inc/cashAdvanceFees')

type Props = {
  isMobile: boolean,
  dispatch: Function,
  handleNext: Function,
  pStudioContent: Object,
  fundingOption: Object,
  isCFPBEnabledCountry: boolean,
  userAccountType: String,
  isCardArtEnabled: boolean,
  isGuest: boolean,
  noteLength: number,
  recipientAccountType: string,
  recipientCountry: string,
  currencyCode: string,
  fromCurrencyCode: string,
}

const ActionButtons = glamorous.button({
  display: 'block',
  margin: '1.25rem auto',
  [mobileAndSmaller]: {
    width: '100%',
  },
})

export class CashAdvanceFees extends Component<Props> {
  componentDidMount() {
    const {
      pStudioContent,
      isGuest,
      fundingOption = {},
      noteLength,
      recipientAccountType,
      recipientCountry,
      currencyCode,
      fromCurrencyCode,
    } = this.props

    const { funding_sources = [{}] } = fundingOption
    const chosen_fi_source = getTheFundingSourceWithCashAdvanceFee(
      funding_sources
    )
    const chosen_fi_id = !isEmpty(chosen_fi_source) ? chosen_fi_source.id : ''

    tracking(
      Events.p2p_fi_warning_screen_shown({
        receiver_country: recipientCountry,
        receiver_currency: currencyCode,
        sender_currency: fromCurrencyCode,
        chosen_fi_id,
        fi_warning_type: 'cash_advance',
        receiver_account_type: recipientAccountType,
        note_character_length: noteLength,
      })
    )
    trackCashAdvanceFeesImpression('warningFeesOverpanel')

    // this one is for personalization studio to track impression count
    // IFF they are a signed in user
    if (!isGuest) {
      const url = get(
        pStudioContent,
        'p2p_cash_advance_fees_disclosure_touchpoint.tracking_details.impression_url',
        {}
      )

      post('/myaccount/transfer/personalization/impression/', {
        url,
      })
    }
  }

  handleClose = () => {
    tracking(
      Events.p2p_fi_warning_update_pressed({
        fi_warning_type: 'cash_advance',
      })
    )
    const isGuest = this.props.isGuest || false
    if (isGuest) {
      back()
      return
    }
    trackCashAdvanceFeesClick('updatePaymentOption')
    this.props.dispatch(
      toggleCashAdvanceFeesOverpanel({ show: false, type: 'ACTIONS' })
    )
  }

  handleContinue = () => {
    tracking(
      Events.p2p_fi_warning_continue_pressed({
        fi_warning_type: 'cash_advance',
      })
    )
    trackCashAdvanceFeesClick('payWithCard')
    this.props.handleNext('cashadvancefee-override-pglk')
  }

  render() {
    const { isMobile, fundingOption = {}, pStudioContent } = this.props
    const pContent = get(
      pStudioContent,
      'p2p_cash_advance_fees_disclosure_touchpoint.content.json',
      {}
    )

    const hasPStudioContent = !isEmpty(pContent)

    const { funding_sources = [{}] } = fundingOption

    const funding_source = getTheFundingSourceWithCashAdvanceFee(
      funding_sources
    )

    const generic_issuer_name =
      funding_source.generic_issuer_name ||
      (hasPStudioContent && pContent.generic_issuer_name
        ? pContent.generic_issuer_name
        : i18n('generic.issuer.name'))

    const titleCss = isMobile
      ? 'ppvx_text--xl ppvx_text--regular'
      : 'ppvx_text--xl2 ppvx_text--regular'

    return (
      <Styles.Container isMobile={isMobile}>
        <Styles.SpecificCardContainer isMobile={isMobile}>
          <Styles.CardImg
            isMobile={isMobile}
            alt=""
            src={generateSourceLogoUrls(
              funding_source,
              this.props.isCFPBEnabledCountry,
              this.props.userAccountType,
              this.props.isCardArtEnabled
            )}
          />
          <Styles.CardDetailsContainer isMobile={isMobile}>
            <Styles.CardDetail className="ppvx_text--md">
              {buildFundingSourceDisplayName(
                funding_source,
                this.props.isCFPBEnabledCountry,
                this.props.userAccountType,
                this.props.isCardArtEnabled
              )}
            </Styles.CardDetail>
            <Styles.CardDetail className="ppvx_text--sm">
              {buildFundingSourceAccountType(funding_source)}
            </Styles.CardDetail>
          </Styles.CardDetailsContainer>
        </Styles.SpecificCardContainer>
        {isDw2Repaint() ? (
          <BodyText strong>
            {hasPStudioContent
              ? pContent.title_heading.replace(
                  '{{issuer}}',
                  generic_issuer_name
                )
              : i18n('actionable.title', {
                  genericIssuerName: generic_issuer_name,
                })}
          </BodyText>
        ) : (
          <Styles.Title isMobile={isMobile} className={titleCss}>
            {hasPStudioContent
              ? pContent.title_heading.replace(
                  '{{issuer}}',
                  generic_issuer_name
                )
              : i18n('actionable.title', {
                  genericIssuerName: generic_issuer_name,
                })}
          </Styles.Title>
        )}
        <Styles.Paragraph isMobile={isMobile}>
          {hasPStudioContent
            ? pContent.body_paragraph_1
            : i18n('actionable.paragraph.one')}
        </Styles.Paragraph>
        {hasPStudioContent && pContent.body_paragraph_2 && (
          <Styles.Paragraph isMobile={isMobile}>
            {hasPStudioContent
              ? pContent.body_paragraph_2
              : i18n('actionable.paragraph.two')}
          </Styles.Paragraph>
        )}
        {isDw2Repaint() ? (
          <Button onClick={this.handleClose} as={ActionButtons}>
            {hasPStudioContent ? pContent.cta_continue : i18n('actionable.cta')}
          </Button>
        ) : (
          <Styles.Button
            isMobile={isMobile}
            className="ppvx_btn"
            onClick={this.handleClose}
          >
            {hasPStudioContent ? pContent.cta_continue : i18n('actionable.cta')}
          </Styles.Button>
        )}
        {isDw2Repaint() ? (
          <Button
            data-nemo="use-credit-card"
            onClick={this.handleContinue}
            as={ActionButtons}
            secondary
          >
            {hasPStudioContent
              ? pContent.cta_submit
              : i18n('actionable.continue')}
          </Button>
        ) : (
          <Styles.Button
            data-nemo="use-credit-card"
            isMobile={isMobile}
            className="ppvx_btn ppvx_btn--secondary"
            onClick={this.handleContinue}
          >
            {hasPStudioContent
              ? pContent.cta_submit
              : i18n('actionable.continue')}
          </Styles.Button>
        )}
      </Styles.Container>
    )
  }
}

export default connect(({ server, note, recipient, amount }) => ({
  isMobile: server.isMobile,
  pStudioContent: server.pStudioContent,
  isCFPBEnabledCountry: server.isCFPBEnabledCountry,
  userAccountType: server.userAccountType,
  isCardArtEnabled: server.features && server.features.isCardArtEnabled,
  noteLength: note.note.length,
  recipientAccountType: recipient.recipientAccountType,
  recipientCountry: recipient.country || 'US',
  currencyCode: amount.currencyCode,
  fromCurrencyCode: amount.fromCurrencyCode,
}))(CashAdvanceFees)
